<div class="px-6 py-4 border-b border-gray-100 bg-white flex flex-row justify-between items-center gap-4">
  <div class="flex items-center gap-3 min-w-0">
    <span class="h-10 w-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center flex-shrink-0"><mat-icon>upload_file</mat-icon></span>
    <div class="min-w-0">
      <h1 class="text-xl font-bold text-gray-900 leading-tight">Import shipments</h1>
      <p class="text-xs text-gray-500 truncate">{{ data.fileName }} - check the changes, nothing is saved yet</p>
    </div>
  </div>
  <button type="button" (click)="dialogRef.close(false)" class="h-9 w-9 rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-800 flex items-center justify-center transition-colors flex-shrink-0" aria-label="Close">
    <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mat-typography !px-6 !py-5 !max-h-[64vh]">
  <!-- Summary -->
  <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
    <div class="rounded-xl bg-emerald-50 border border-emerald-100 px-4 py-3">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-emerald-700/70">New</div>
      <div class="text-2xl font-bold text-emerald-700">{{ creates }}</div>
    </div>
    <div class="rounded-xl bg-sky-50 border border-sky-100 px-4 py-3">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-sky-700/70">Updated</div>
      <div class="text-2xl font-bold text-sky-700">{{ updates }}</div>
    </div>
    <div class="rounded-xl border px-4 py-3" [ngClass]="warningCount ? 'bg-amber-50 border-amber-100' : 'bg-gray-50 border-gray-100'">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-500">Warnings</div>
      <div class="text-2xl font-bold" [ngClass]="warningCount ? 'text-amber-700' : 'text-gray-300'">{{ warningCount }}</div>
    </div>
    <div class="rounded-xl border px-4 py-3" [ngClass]="errorCount ? 'bg-red-50 border-red-100' : 'bg-gray-50 border-gray-100'">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-500">Errors</div>
      <div class="text-2xl font-bold" [ngClass]="errorCount ? 'text-red-600' : 'text-gray-300'">{{ errorCount }}</div>
    </div>
  </div>

  @if (errorCount) {
  <div class="mb-4 flex items-start gap-2 rounded-xl bg-red-50 border border-red-200 px-3 py-2.5 text-sm text-red-800">
    <mat-icon class="!text-[18px] !h-[18px] !w-[18px] flex-shrink-0 mt-px">error_outline</mat-icon>
    <span>Fix the errors in the file and import it again - nothing is saved while any shipment has an error.</span>
  </div>
  }

  <!-- Per shipment -->
  <div class="flex flex-col gap-2.5">
    @for (r of data.results; track r.key) {
    <div class="rounded-xl border px-4 py-3" [ngClass]="r.errors.length ? 'border-red-200 bg-red-50/30' : 'border-gray-200 bg-white'">
      <div class="flex items-center gap-2 flex-wrap">
        <span class="text-[10px] font-bold uppercase tracking-wider rounded-full px-2 py-0.5"
          [ngClass]="r.action === 'create' ? 'bg-emerald-100 text-emerald-700' : 'bg-sky-100 text-sky-700'">{{ r.action === 'create' ? 'New' : 'Update' }}</span>
        <span class="font-bold text-gray-900">{{ r.reference || r.key }}</span>
        <span class="text-xs text-gray-400">{{ r.containers }} container{{ r.containers === 1 ? '' : 's' }} &middot; {{ r.lines }} line{{ r.lines === 1 ? '' : 's' }}</span>
        @if (!r.errors.length) { <mat-icon class="ml-auto !text-[18px] !h-[18px] !w-[18px] text-emerald-500">check_circle</mat-icon> }
      </div>
      @for (e of r.errors; track $index) {
      <div class="mt-1.5 flex items-start gap-1.5 text-xs text-red-700"><mat-icon class="!text-[14px] !h-3.5 !w-3.5 flex-shrink-0 mt-px">close</mat-icon>{{ e }}</div>
      }
      @for (w of r.warnings; track $index) {
      <div class="mt-1.5 flex items-start gap-1.5 text-xs text-amber-800"><mat-icon class="!text-[14px] !h-3.5 !w-3.5 flex-shrink-0 mt-px">warning_amber</mat-icon>{{ w }}</div>
      }
    </div>
    }
  </div>
</mat-dialog-content>

<div class="px-6 py-4 border-t border-gray-100 bg-white flex flex-row items-center justify-between gap-3 flex-wrap">
  <span class="text-xs text-gray-400">Updates replace each shipment's lines and containers with the file's.</span>
  <div class="flex items-center gap-3">
    <button type="button" (click)="dialogRef.close(false)" class="px-5 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors">Cancel</button>
    <button type="button" [disabled]="applying || errorCount > 0" (click)="apply()"
      class="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 font-bold text-sm shadow-md shadow-amber-200 hover:from-amber-300 hover:to-amber-400 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none">
      @if (applying) { <mat-spinner diameter="16"></mat-spinner> } @else { <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">check</mat-icon> }
      Import {{ data.results.length }} shipment{{ data.results.length === 1 ? '' : 's' }}
    </button>
  </div>
</div>
